export default "__VITE_ASSET__Cj8m8Ovn__"